import { Modal } from 'antd';
import React from 'react';

export type ModalProps = {
  className?: string;
  isOpen: boolean;
  children?: React.ReactNode;
  width?: number | string;
  onClose?: () => void;
};

const CustomModal: React.FC<ModalProps> = ({ className, isOpen, children, width = 800, onClose }) => {
  return (
    <Modal
      open={isOpen}
      footer={null}
      onCancel={onClose}
      width={width}
      data-testid="custom-modal"
      className={className}
    >
      {children}
    </Modal>
  );
};

export default CustomModal;
